import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-ink-900 text-white flex flex-col">
            <Header />
            <main className="flex-1 pt-16 md:pt-24" data-testid="site-main">
                {children}
            </main>
            <Footer />
        </div>
    );
}
